import styled from 'styled-components';

import { SkeletonLoader } from '@pkg/components/SkeletonLoader';

export const NFTAssetLoader = styled(SkeletonLoader)`
    height: 100%;
    background: #000, radial-gradient(100% 0%, rgba(255, 255, 255, 1) 100%, rgba(255, 255, 255, 1) 100%);
    border-radius: 6px 6px 0 0;
`;
